import Vue from "vue";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
	public static async init() {
		await Localizer.init({
			defaultCulture: (<any>window).App.culture,
			resourceContexts: ["App", "Account", "CookieToast", "Contact"]
		});

		let DataWeb = (<any>window).DataWeb;
		if (DataWeb) {
			Vue.use(DataWeb.default);
			Vue.use(DataWebConfig);

			await DataWeb.Localizer.init({
				defaultCulture: (<any>window).App.userCulture,
				resourceContexts: ["DataWeb", "Account"]
			});
		}

		this.initRequestVerificationToken();

		AppConfig.AddComponents();
		AppConfig.AddDirectives();

		let vm = new Vue({
			el: "#app",
			router,
			store,
			created() {
				if (DataWeb) {
					DataWeb.default.registerRoutes(router);
					DataWeb.default.registerStoreModules(store);
				}
			},
		});

		(<any>window).App.instances.vm = vm;

		this.setNavigation();
		this.setBackgroundColor();
		this.setCtaFooter();
		this.openInfoRequest();
		this.setAnalytics();
	}

	private static initRequestVerificationToken() {
		var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
		if (antiforgerytoken) {
			Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
		}
	}

	private static setNavigation() {
		let app = document.getElementById("body");
		let header = document.getElementById("Header");
		let wrapMenuSupportLink = document.querySelectorAll(".button[data-service]");
		let hamburgermenu = document.querySelector(".button[data-menu]");
		let turnback = document.querySelector(".button[data-back]");

		for (const wrapMenuLink of wrapMenuSupportLink) {
			wrapMenuLink.addEventListener("click", (e) => {
				let parentElement = (<HTMLElement>e.target).parentElement;

				document.querySelectorAll(".item[data-type]").forEach((doc) => doc.classList.remove("active"));
				document.querySelector(".item[data-type=" + parentElement.dataset.type + "]").classList.add("active");
				header.classList.add("service-show");
				app.classList.add("overflow");
			});
		}

		hamburgermenu.addEventListener("click", function () {
			header.classList.add("menu-show");
			app.classList.add("overflow");
		});

		turnback.addEventListener("click", function () {
			document.querySelectorAll(".item[data-type]").forEach((doc) => doc.classList.remove("active"));
			header.classList.remove("service-show");
		});

		function closeOverlay() {
			document.querySelectorAll(".item[data-type]").forEach((doc) => doc.classList.remove("active"));
			header.classList.remove("service-show");
			header.classList.remove("menu-show");
			app.classList.remove("overflow");
		}

		let serviceClose = document.querySelectorAll(".button[data-close]");
		if (serviceClose && serviceClose.length != 0) {
			for (let i = 0; i < serviceClose.length; i++) {
				serviceClose[i].addEventListener("click", closeOverlay);
			}
			window.addEventListener("resize", closeOverlay);
		}

		if (header) {
			window.addEventListener("scroll", function () {
				if (window.scrollY > 0) {
					header.setAttribute("data-minify", "");
					header.setAttribute("data-hide", "");
				} else {
					header.removeAttribute("data-minify");
					header.removeAttribute("data-hide");
				}
			});

			let posizioneScroll = window.scrollY;

			window.addEventListener("scroll", function () {
				if (window.scrollY < posizioneScroll) {
					header.removeAttribute("data-hide");
				}
				posizioneScroll = window.scrollY;
			});
		}
	}

	private static setBackgroundColor() {
		window.addEventListener("scroll", (event) => {
			let panel = document.querySelectorAll(".layout"),
				header = document.getElementById("Header"),
				scroll = window.scrollY + window.screen.height / 10;

			for (var i = 0; i < panel.length; i++) {
				let thisPanel = panel[i];

				if ((<HTMLElement>thisPanel).offsetTop <= scroll && (<HTMLElement>thisPanel).offsetTop + (<HTMLElement>thisPanel).offsetHeight > scroll) {
					document.body.classList.remove("light-layout");
					document.body.classList.remove("dark-layout");
					document.body.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
					header.classList.remove("light-layout");
					header.classList.remove("dark-layout");
					header.classList.add((<HTMLElement>thisPanel).dataset.layout + "-layout");
				}
			}
		});
	}

	private static setCtaFooter() {
		let wrapper;
		const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

		async function writingAll(stringTarget, container) {
			wrapper = document.querySelector("[" + container + "]");
			const stringsContainer = document.getElementsByClassName(stringTarget);
			const icons = document.querySelectorAll(".icon");

			while (wrapper) {
				for (let i = 0; i < stringsContainer.length; i++) {
					const string = stringsContainer[i].textContent;
					let currentIcon = icons[i];
					for (const item of icons) {
						item.classList.remove("active");
					}
					currentIcon.classList.add("active");
					await write(string);
					await sleep(1000);
					await erase();
					await sleep(300);
				}
			}
		}

		async function write(text) {
			let index = 0;
			while (index < text.length) {
				const timeout = 50;
				await sleep(timeout);
				wrapper.innerHTML = text.substring(0, index);
				index++;
			}

		}

		async function erase() {
			while (wrapper.textContent.length) {
				const timeout = 50;
				await sleep(timeout);
				wrapper.textContent = wrapper.textContent.substring(
					0,
					wrapper.textContent.length - 2
				);
			}
		}

		writingAll("message", "data-text");
	}

	private static openInfoRequest() {
		let buttons = document.querySelectorAll(".is-info-request");
		for (const item of buttons) {
			item.addEventListener("click", (x) => {
				(<any>window).App.instances.vm.$store.commit("infoRequestStore/setInfoRequestVisible", true);
				var galabel = item.getAttribute("data-galabel") ? item.getAttribute("data-galabel") : "editor";
				GTagHelper.sendEvent("click", "info_request_open", galabel);
			});
		}
	}

	private static setAnalytics() {
		let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
		for (const item of dataGaeventLinkTrue) {
			if (item) {
				item.addEventListener("click", function (event) {
					GTagHelper.sendEvent(
						this.getAttribute("data-ganame") ? this.getAttribute("data-ganame") : "click",
						this.getAttribute("data-gacategory"),
						this.getAttribute("data-galabel") === "link" ? this.getAttribute("href") : this.getAttribute("data-galabel"),
					);
				});
			}
		}

		let gaEventEditorItems = document.querySelectorAll(".editor a");
		if (gaEventEditorItems && gaEventEditorItems.length != 0) {
			for (let i = 0; i < gaEventEditorItems.length; i++) {
				gaEventEditorItems[i].addEventListener("click", function () {
					GTagHelper.sendEvent("click", "link", gaEventEditorItems[i].getAttribute("href"));
				});
			}
		}
	}
}
